import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";

//Configuración de las reglas de la votación pública: verificación por SMS y qué
//hacer con los emails y teléfonos repetidos.
//
//Hasta ahora estas tres opciones existían en la base pero no había forma de
//tocarlas desde la consola: había que pedirle al Programa que las cambiara a
//mano. Las listas de excepciones se leen y se guardan por la ruta privada
///api/municipios/auth/:id, porque son datos personales de vecinos y el schema
//las tiene con select:false para que no salgan por la ruta pública.

//Convierte la lista guardada en el texto que se muestra en el textarea.
const aTexto = (lista) => (Array.isArray(lista) ? lista.join("\n") : "");

const AdminVotacionConfig = (props) => {
  const municipio = props.municipio;
  const [datos, guardarDatos] = useState(undefined);
  const [error, guardarError] = useState(false);

  useEffect(() => {
    let vigente = true;
    axios
      .get(`/api/municipios/auth/${municipio._id}`)
      .then((res) => {
        if (vigente) guardarDatos(res.data);
      })
      .catch(() => {
        if (vigente) guardarError(true);
      });
    return () => {
      vigente = false;
    };
  }, [municipio._id]);

  //La configuración solo interviene en la votación pública: el voto que se
  //carga desde la consola no pasa por estos controles.
  if (municipio.tipoVotacion !== "publica") return null;
  if (error) return null;
  if (datos === undefined) return null;

  //El formulario se monta recién con los datos cargados para que react-hook-form
  //reciba los valores iniciales correctos.
  return <Formulario municipio={municipio} datos={datos} />;
};

const Formulario = (props) => {
  const { municipio, datos } = props;
  const usaSMS = datos.municipio.verificacionSMS === true;

  const { register, handleSubmit, watch, reset, formState } = useForm({
    defaultValues: {
      noAceptarEmailRepetido: datos.municipio.noAceptarEmailRepetido === true,
      noAceptarTelRepetido: datos.municipio.noAceptarTelRepetido === true,
      emailsRepeticionPermitida: aTexto(
        datos.municipio.emailsRepeticionPermitida
      ),
      telsRepeticionPermitida: aTexto(datos.municipio.telsRepeticionPermitida),
    },
  });

  const sinEmailRepetido = watch("noAceptarEmailRepetido");
  const sinTelRepetido = watch("noAceptarTelRepetido");

  const onSubmit = (data) => {
    //Las listas van tal como se escribieron: el servidor las normaliza (emails
    //en minúsculas, teléfonos a 10 dígitos) y devuelve el resultado, que es lo
    //que se vuelve a mostrar. Así el admin ve exactamente qué quedó guardado.
    axios
      .put(`/api/municipios/${municipio._id}`, data)
      .then((res) => {
        const guardado = res.data.municipioActualizado;
        reset({
          noAceptarEmailRepetido: guardado.noAceptarEmailRepetido === true,
          noAceptarTelRepetido: guardado.noAceptarTelRepetido === true,
          emailsRepeticionPermitida: aTexto(guardado.emailsRepeticionPermitida),
          telsRepeticionPermitida: aTexto(guardado.telsRepeticionPermitida),
        });
        Swal.fire("Se guardó la configuración de la votación", "", "success");
      })
      .catch((err) => {
        Swal.fire(
          err.response && err.response.data && err.response.data.errorMessage
            ? err.response.data.errorMessage
            : "Ocurrió un error, por favor inténtelo de nuevo o pónganse en contacto.",
          "",
          "error"
        );
      });
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-md-12">
          <h2 className="ppr-titulo centrado my-2 h4">
            Configuración de la Votación
          </h2>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8 mx-auto">
          <form className="m-3" onSubmit={handleSubmit(onSubmit)}>
            {/*Verificación por SMS: solo se informa el estado.
               No es un interruptor porque prenderla empieza a gastar plata y la
               configura el Programa. El servidor además rechaza el cambio si
               llegara por otro lado (CAMPOS_NO_EDITABLES).*/}
            <div className="form-group mb-4">
              <p className="mb-1">
                <b>Verificación del teléfono por SMS: </b>
                <span
                  className={`badge ${
                    usaSMS ? "badge-success" : "badge-secondary"
                  }`}
                >
                  {usaSMS ? "Activada" : "Desactivada"}
                </span>
              </p>
              <small className="form-text text-muted">
                {usaSMS
                  ? "Al votar se envía un código de 6 dígitos al celular y hay que escribirlo para poder terminar."
                  : "Al votar no se pide ningún código: alcanza con completar el formulario."}{" "}
                La activa o desactiva el Programa Raíz, porque cada mensaje tiene
                costo. Si querés cambiarla, escribinos.
              </small>
            </div>

            <hr />

            {/*Email repetido*/}
            <div className="form-group mb-4">
              <div className="custom-control custom-switch py-2">
                <input
                  {...register("noAceptarEmailRepetido")}
                  type="checkbox"
                  className="custom-control-input"
                  id="noAceptarEmailRepetido"
                />
                <label
                  className="custom-control-label"
                  htmlFor="noAceptarEmailRepetido"
                >
                  Rechazar el voto si el email ya votó
                </label>
              </div>
              <small className="form-text text-muted">
                Si está apagado, el voto se acepta igual y queda marcado como
                "Email Repetido" para revisarlo al fiscalizar.
              </small>

              {sinEmailRepetido && (
                <div className="mt-3">
                  <label htmlFor="emailsRepeticionPermitida">
                    Emails que sí pueden repetirse:
                  </label>
                  <textarea
                    {...register("emailsRepeticionPermitida")}
                    className="form-control"
                    id="emailsRepeticionPermitida"
                    rows={4}
                    placeholder={"familia@gmail.com\nmunicipio@ejemplo.gob.ar"}
                  />
                  <small className="form-text text-muted">
                    Uno por línea (o separados por comas). Son las excepciones:
                    una familia que comparte una única casilla, o el correo del
                    municipio si se usa para cargar votos. Se guardan en
                    minúsculas.
                  </small>
                </div>
              )}
            </div>

            <hr />

            {/*Teléfono repetido*/}
            <div className="form-group mb-4">
              <div className="custom-control custom-switch py-2">
                <input
                  {...register("noAceptarTelRepetido")}
                  type="checkbox"
                  className="custom-control-input"
                  id="noAceptarTelRepetido"
                />
                <label
                  className="custom-control-label"
                  htmlFor="noAceptarTelRepetido"
                >
                  Rechazar el voto si el teléfono ya votó
                </label>
              </div>
              <small className="form-text text-muted">
                Si está apagado, el voto se acepta igual y queda marcado como
                "Teléfono Repetido" para revisarlo al fiscalizar.
              </small>

              {sinTelRepetido && (
                <div className="mt-3">
                  <label htmlFor="telsRepeticionPermitida">
                    Teléfonos que sí pueden repetirse:
                  </label>
                  <textarea
                    {...register("telsRepeticionPermitida")}
                    className="form-control"
                    id="telsRepeticionPermitida"
                    rows={4}
                    placeholder={"3512345678\n3585123456"}
                  />
                  <small className="form-text text-muted">
                    Uno por línea. Diez dígitos: código de área y número, sin el
                    0 y sin el 15. Los que no tengan esa forma se descartan al
                    guardar.
                  </small>
                </div>
              )}
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="btn ppr-btn-azul font-weight-bold m-2"
                disabled={formState.isSubmitting}
              >
                Guardar Configuración
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default AdminVotacionConfig;
